import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { ITMethodDto } from './it-method-dto.model';


export class EmployeeITMethodDto implements IEmployeeITMethodDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    financialYear!: string | undefined;
    itMethod!: ITMethodDto;

    constructor(data?: IEmployeeITMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.financialYear = _data["financialYear"];
            this.itMethod = _data["itMethod"] ? ITMethodDto.fromJS(_data["itMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeITMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeITMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["financialYear"] = this.financialYear;
        data["itMethod"] = this.itMethod ? this.itMethod.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEmployeeITMethodDto {
    id: number;
    employee: EmployeeSummaryDto;
    financialYear: string | undefined;
    itMethod: ITMethodDto;
}

